import * as React from "react";
const SvgFiRrTriangle = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="#062147"
      d="M19.948 24H4.052a4.03 4.03 0 0 1-4.048-3.818 3.95 3.95 0 0 1 .414-1.954L8.38 4.212a4.068 4.068 0 0 1 7.253.026l7.922 13.94a3.97 3.97 0 0 1-.156 3.91A4.03 4.03 0 0 1 19.95 24M12 4a2.01 2.01 0 0 0-1.842 1.129l-.026.049-7.948 13.989a1.92 1.92 0 0 0 .116 1.867A2.04 2.04 0 0 0 4.052 22h15.9a2.04 2.04 0 0 0 1.752-.966 1.94 1.94 0 0 0 .09-1.916l-7.926-13.94A2.04 2.04 0 0 0 12 4"
    />
  </svg>
);
export default SvgFiRrTriangle;
